import EshopError from "../models/eshopError";

export default function isErrorResponse(response: any | EshopError): response is EshopError {
  return (response as EshopError).type !== undefined && response.status >= 400;
}
